<sd-modal #modal
  [type]="modalType"
  [clickToClose]="true"
  [clickToOpen]="clickToOpen"
  [modalCustomClass]="dropdownCustomClass"
  [modalCustomId]="dropdownCustomId"
  [focus]="focus"
  [position]="icon ? positionEnum.bottomRight : positionEnum.bottomLeft"
  [(isOpened)]="isOpened"
  (isOpenedChange)="isOpenedChange.emit($event)"
  [disabled]="disabled || readonly"
>
  @if (!icon && !isAutocomplete) {
    <button sd-button
      type="button"
      [brand]="brand"
      [id]="uuidButton"
      class="c__toggle is-reset"
      [attr.aria-labelledby]="labeledBy + ' ' + uuidButton"
      [iconPos]="positionEnum.right"
      [icon]="isOpened ? 'icon-arrow-up' : 'icon-arrow-down'"
      [isSmall]="isBtnSmall"
      [ngClass]="{ 'is-active': isOpened, 'is-selected': isSelected }"
      [disabled]="disabled || readonly"
      [attr.aria-expanded]="isOpened"
      (click)="notifyButtonSizeOnClick($event)"
    >
      <ng-content select="[sd-dropdown-button]" />
    </button>
  }

  @if (icon) {
    <button sd-button-icon
      [brand]="brand"
      type="button"
      class="c__toggle is-full-area {{isOpened ? 'is-open' : ''}}"
      [title]="buttonIconTitle ? buttonIconTitle : ''"
      [buttonIconTitle]="buttonIconTitle"
      [titleHidden]="buttonIconTitleHidden"
      [attr.aria-expanded]="isOpened"
      [size]="iconSize"
      [icon]="icon"
    >
      @if (iconLabel) {
        <span class="c__icon-label">{{iconLabel}}</span>
      }
    </button>
  }

  @if (isAutocomplete) {
    <sd-theme-wrapper [brand]="brand">
      <ng-content select="[sd-dropdown-input]" />
    </sd-theme-wrapper>
  }

  <div class="c__modal-wrapper c__dropdown-menu {{isCustomDropdown ? 'is-custom' : ''}}" sdUpDown sd-modal-body>
    <sd-theme-wrapper [brand]="brand">
      <ng-content select="[sd-dropdown-menu]" />
    </sd-theme-wrapper>
  </div>
</sd-modal>
